<template>
  <div data-qa="lpu_cards">
    <div
      v-for="lpu in lpus"
      :key="lpu.translit"
      data-qa="lpu_cards_item"
      :data-qa-translit="lpu.translit"
      class="d-flex flex-column align-center gr-4 pa-4 elevation-1 rounded"
    >
      <LpuLogoPicture
        v-if="ff_update_lpu_logo"
        img-class="flex-grow-0"
        contain
        width="240"
        height="80"
        alt="/"
        :files="lpu.logoFiles"
      />
      <v-img
        v-else
        :src="lpu.avatar"
        class="flex-grow-0"
        lazy-src="/static/_v1/pd/icons/ui-kit/photo/no-avatar-lpu.svg"
        width="240"
        height="80"
        alt="/"
        contain
      />
      <div class="d-flex flex-column text-center gr-1">
        <a
          data-qa="lpu_cards_item_url"
          :href="lpu.url"
          class="text-subtitle-1 primary--text text-decoration-none"
        >
          {{ lpu.name }}
        </a>
        <div
          data-qa="lpu_cards_item_town_name"
          class="text-body-2 text-secondary--text"
        >
          {{ lpu.townName }}
        </div>
        <div class="text-body-2 text-secondary--text">
          {{ t('Заблокирована до', options) }}
          <span data-qa="lpu_cards_item_fraud_mark_expire_date">{{ lpu.fraudMarkExpireDate }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { Lpu } from 'src/components/pages/info/shame-mark/ShameMarkContent/types'
import LpuLogoPicture from 'src/components/common/LpuLogoPicture/LpuLogoPicture.vue'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/info/shame-mark/types'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  lpus: Lpu[]
}>()

const { context }: ContextStore = useContextStore()
const ff_update_lpu_logo = computed(() => Boolean(context.request.feature_flags.ff_update_lpu_logo))
</script>
